module.exports = __webpack_public_path__ + "static/img/miehuotan.5475993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miehuotan.png
// module id = PKkO
// module chunks = 21